import React from 'react'

import { Background } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import { CatalogExplorer } from 'components/CatalogExplorer'
import { FAQ } from 'components/FAQ'
import { Subscription } from 'components/Subscription'
import { EventTypes } from 'libs/events'

type GrowthFooterSectionProos = {
  location: 'hub' | 'camp'
}

export const GrowthFooterSection = ({ location }: GrowthFooterSectionProos) => {
  const { t } = useTranslation('@mc/next')

  return (
    <Background color='dark' className='mc-theme-dark mc-py-10 mc-mt-12'>
      <CatalogExplorer
        className='container mc-mt-10'
        arialabelledBy='sessions-catalog-explorer'
        heading={
          <h2
            className='mc-text-h2 mc-mb-10 mc-text--center'
            id='sessions-catalog-explorer'
          >
            {t('sessions.common.catalogExplorer')}
          </h2>
        }
      />
      <Subscription />
      <FAQ
        className='container mc-py-10'
        eventType={
          location === 'hub'
            ? EventTypes.EXPLAINER_PAGE_CLICK
            : EventTypes.SESSION_COURSE_MARKETING_PAGE_CLICK
        }
        eventLocation={`mastercamp-${location}-faq`}
      />
    </Background>
  )
}
